import { auth } from "api-client";

import PaltaCombo from "@palta-ui/combo";

export default {
  extends: PaltaCombo,
  props: {
    labelKey: {
      default: "description",
    },
  },
  data() {
    return {
      url: "languages",
      model: "languages",
      api: auth,
      itemOptions: {
        itemValueKey: "description",
      },
      filters: [
        {
          type: "string",
          id: "search",
          key: "description",
          visible: false,
          condition: "S1",
        },
      ],
    };
  },
};
